import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';



@NgModule({
  declarations: [MaintenancePageComponent],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [MaintenancePageComponent]
})
export class MaintenanceModule { }
